"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _g;
var HomeVisit = function HomeVisit(props) {
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({
    viewBox: "0 0 30 28"
  }, props), _g || (_g = /*#__PURE__*/_react.default.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M25.723 12.24v12.24c0 .902-.887 1.633-1.982 1.633H6.46c-1.095 0-1.982-.731-1.982-1.633V12.24"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.999 1.398L28.242 14.64M15.014 1.38L1.14 15.252",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.136 25.792h5.928v-8.9h-5.928v8.9z"
  }))));
};
var _default = exports.default = HomeVisit;